module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-status', {
    staticStyle: {
      "padding": "1px 0px"
    },
    attrs: {
      "with-dropdown": _vm.groups && _vm.groups.length > 0,
      "practitioner": _vm.currentUser
    },
    on: {
      "selected": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('v-card', [_c('grouped-practitioner-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    attrs: {
      "groups": _vm.groups,
      "withActivate": false
    },
    on: {
      "selected": _vm.triggerBecome
    }
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.switching')) + "\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [(_vm.requestStatus !== 200) ? _c('v-progress-circular', {
    attrs: {
      "color": "amber",
      "size": 70,
      "indeterminate": true
    }
  }) : _c('v-icon', {
    attrs: {
      "size": 70,
      "color": "green"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), (_vm.status === "switching") ? _c('p', {
    staticClass: "subheading"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.progress', {
    user: _vm.currentUser.first_name
  })) + "\n          ")]) : (_vm.status === "success") ? _c('p', {
    staticClass: "subheading"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.success', {
    user: _vm.currentUser.first_name
  })) + "\n          ")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72aaef74","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/AccountSwitcher.vue
// module id = 1467
// module chunks = 9